export const skills = [
    "HTML",
    "CSS",
    "React.js",
    "Node.js(Beginner)",
    "JAVA",
    "JavaScript",
    "Python",
    "SQL(MySQL)",
    "Tailwind(Beginner)",
    "SpringBoot(Beginner)",
    "C/C++",
    "Git"
  ];